<!-- Modal de Facturas Pendientes -->
<div
  class="modal fade"
  id="modalFacturasPendientes"
  tabindex="-1"
  aria-labelledby="modalFacturasPendientesLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-warning">
      <div class="modal-header bg-warning text-dark">
        <h5 class="modal-title" id="modalFacturasPendientesLabel">
          <i class="fas fa-exclamation-triangle me-2"></i>
          Aviso Importante
        </h5>
      </div>
      <div class="modal-body text-center">
        <div class="mb-3">
          <i class="fas fa-file-invoice-dollar fa-3x text-warning mb-3"></i>
        </div>
        <h6 class="fw-bold text-dark mb-3">
          Tiene facturas pendientes de pago
        </h6>
        <p class="text-muted mb-3">Por favor, regularice su situación.</p>
        <p class="text-muted mb-3">
          Si usted ya abonó las facturas pendientes, contacte con el área de
          administración al 0341 437-5281
        </p>
        <div class="alert alert-info d-flex align-items-center" role="alert">
          <i class="fas fa-clock me-2"></i>
          <small>
            <strong>Tiempo de sesión limitado:</strong>
            {{ tiempoRestanteSesion }}. Deberá iniciar sesión nuevamente al
            finalizar este tiempo.
          </small>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <button
          type="button"
          class="btn btn-warning"
          (click)="onEntendidoClick()"
        >
          <i class="fas fa-check me-1"></i>
          Entendido
        </button>
      </div>
    </div>
  </div>
</div>
